<template>
  <div class="order-menu-pack">
    <div class="order-menu-pack__header">
      <p class="order-menu-pack__type">
        {{ mealTitle }}
      </p>
      <p
        v-if="showCalories"
        class="order-menu-pack__kcal"
      >
        {{ pack.energyData.kcal }} Ккал
      </p>
    </div>
    <img
      :src="image"
      :alt="pack.title"
      height="92"
      class="order-menu-pack__img"
    >
    <p class="order-menu-pack__description">
      {{ pack.title }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'MenuPack',

  props: {
    pack: {
      type: Object,
      required: true,
    },

    showCalories: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    image () {
      return this.pack.packImage?.imageURL2x
    },

    mealTitle () {
      const title = this.pack.mealTitle
      if (title.length > 15) {
        return title.split(' ')[0]
      }
      return title
    },
  },
}
</script>

<style lang="scss">
.order-menu-pack {
  background-color: map-get($colors, 'grey_4');
  border-radius: 16px;
  padding: 8px 16px 20px 12px;
  height: 208px;

  &__header {
    display: flex;
    justify-content: space-between;
    height: 16px;
    align-items: center;
    margin-bottom: 8px;
    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
  }

  &__type {
    text-transform: uppercase;
    color: map-get($colors, 'secondary');
    letter-spacing: 0.7px;
  }

  &__kcal {
    color: map-get($colors, 'black');
  }

  &__img {
    height: 92px;
    object-fit: contain;
    margin-bottom: 12px;
  }

  &__description {
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
